import { serverSideTranslations } from '@holo/i18n/serverSideTranslations';
import { initApolloClient, addApolloCache } from '@holo/client';
import { ProductDocument, PreRenderProductsDocument } from '@holo/gql';
import Product from '@/components/Product';
import type { GetStaticPaths, GetStaticProps } from 'next';
import type { ProductQuery, PreRenderProductsQuery } from '@holo/gql';

const NUMBER_OF_PRODUCTS = process.env.DEV_BUILD ? 1 : 400;

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  const apolloClient = initApolloClient();
  const translations = await serverSideTranslations(locale);

  try {
    const data = await apolloClient.query<ProductQuery>({
      query: ProductDocument,
      variables: {
        id: params?.id,
      },
    });

    return addApolloCache(apolloClient, {
      props: {
        ...translations,
        ...data,
      },
      revalidate: 600,
    });
  } catch (_err) {
    return {
      notFound: true,
    };
  }
};

export const getStaticPaths: GetStaticPaths = async () => {
  const apolloClient = initApolloClient();

  const { data } = await apolloClient.query<PreRenderProductsQuery>({
    query: PreRenderProductsDocument,
    variables: {
      take: NUMBER_OF_PRODUCTS,
    },
  });

  return {
    paths: data?.products.edges.map(
      (product: any) => `/${product?.node?.producer?.slug}/product/${product?.node?.id}/retail`,
    ),
    fallback: 'blocking',
  };
};

type Props = {
  data: ProductQuery;
};

const Retail = ({ data }: Props) => {
  return <Product data={data} type="retail" />;
};

export default Retail;
